/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Venues_LinkInputs */

const cs_settings_office_venues_link = /** @type {(inputs: Settings_Office_Venues_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spravovat pobočky`)
};

const en_settings_office_venues_link = /** @type {(inputs: Settings_Office_Venues_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage branches`)
};

/**
* | output |
* | --- |
* | "Manage branches" |
*
* @param {Settings_Office_Venues_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_venues_link = /** @type {((inputs?: Settings_Office_Venues_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Venues_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_venues_link(inputs)
	return cs_settings_office_venues_link(inputs)
});